interface ClipboardWriter {
  writeText(value: string): Promise<void>;
}

const initializedRoots = new WeakSet<Document>();

export function initializeCopyText(
  root: Document = document,
  clipboard: ClipboardWriter | undefined = navigator.clipboard) {
  if (initializedRoots.has(root)) return;
  initializedRoots.add(root);

  root.addEventListener("click", event => {
    const target = event.target as Element | null;
    const button = target?.closest<HTMLButtonElement>("[data-copy-text]");
    if (!button) return;

    event.preventDefault();
    void copyText(button, root, clipboard);
  });
}

async function copyText(
  button: HTMLButtonElement,
  root: Document,
  clipboard: ClipboardWriter | undefined) {
  const sourceId = button.dataset.copyText;
  const source = sourceId ? root.getElementById(sourceId) : null;
  if (!source) return;

  const value = "value" in source && typeof source.value === "string"
    ? source.value
    : source.textContent ?? "";
  const label = button.querySelector<HTMLElement>("[data-copy-text-label]");
  const defaultLabel = label?.dataset.copyTextDefaultLabel ?? label?.textContent ?? "Copy";
  if (label) label.dataset.copyTextDefaultLabel = defaultLabel;

  try {
    if (!clipboard) throw new Error("Clipboard access is unavailable.");
    await clipboard.writeText(value);
    button.dataset.copyTextState = "copied";
    if (label) label.textContent = "Copied";
    window.setTimeout(() => {
      delete button.dataset.copyTextState;
      if (label?.isConnected) label.textContent = defaultLabel;
    }, 1800);
  } catch {
    if ("focus" in source && typeof source.focus === "function") source.focus();
    if ("select" in source && typeof source.select === "function") source.select();
    button.dataset.copyTextState = "manual";
    if (label) label.textContent = "Press Ctrl+C";
  }
}
